function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8bI7u", function(module, exports) {
    $parcel$export(module.exports, "PendoAnalytics", ()=>$929eebe0cae53103$export$5b517672761df363);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $kTK0a;
    var $902O6;
    var $fG5AJ;
    var $10xFf;
    var $2vSU6;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $bw7Gm;
    var $dAfqg;
    var $2tT7R;
    var $9OXo1;
    var $eJqJI;
    parcelRequire("fHuqs");
    let $929eebe0cae53103$var$pendingRequestJira = Promise.resolve();
    function $929eebe0cae53103$var$reportError(error, id, message) {
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: id,
                packageName: 'jiraCommonPendoAnalytics'
            },
            attributes: {
                message: message
            },
            error: error
        });
    }
    const $929eebe0cae53103$var$initializePendoWithChecking = async (apiKey, appName, pendoConfig, environment)=>{
        const id = `pendo-agent-${apiKey}`;
        try {
            if (window.pendo && window.pendo.teardown && apiKey !== window.pendo.apiKey) {
                window.pendo.teardown();
                delete window.pendo;
            }
        } catch (error) {
            $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsTeardown', 'Failed to teardown pendo');
        }
        await (0, (0, parcelRequire("902O6")).checkThirdParty)('pendo-main', async ()=>{
            const config = (0, (0, parcelRequire("4R6GH")).fg)('post-office_enable_pendo_choreographer') ? (0, (0, parcelRequire("fG5AJ")).getPendoPlugin)((0, (0, parcelRequire("10xFf")).environmentToEnvType)(environment)).getPendoConfig(pendoConfig) : pendoConfig;
            if (!(0, (0, parcelRequire("co1wz")).ff)('pendo-jira-load-only-for-eng-users_q9w6l') || pendoConfig?.visitor?.language_preference.startsWith('en')) {
                let script = document.getElementById(id);
                if (script) {
                    window.pendo = window[id];
                    try {
                        if (window?.globalPendoAppName === appName) {
                            const updateInterval = setInterval(()=>{
                                if (window.pendo !== undefined && typeof window.pendo.initialize === 'function' && typeof window.pendo.updateOptions === 'function') {
                                    if (apiKey !== window?.pendo?.apiKey) window.pendo.initialize(config);
                                    else window.pendo.updateOptions(config);
                                    clearInterval(updateInterval);
                                }
                            }, 1000);
                        }
                    } catch (error) {
                        $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsInitializeUpdate', 'Failed to initialize/update pendo');
                    }
                } else {
                    script = document.createElement('script');
                    script.id = id;
                    if (script instanceof HTMLScriptElement) script.defer = true;
                    script.onload = ()=>{
                        window[id] = window.pendo;
                        try {
                            if (window?.globalPendoAppName === appName) {
                                const initializeInterval = setInterval(()=>{
                                    if (window.pendo !== undefined && typeof window.pendo.initialize === 'function') {
                                        window.pendo.initialize(config);
                                        clearInterval(initializeInterval);
                                    }
                                }, 1000);
                            }
                        } catch (error) {
                            $929eebe0cae53103$var$reportError(error, 'jiraPendoAnalyticsInitialize', 'Failed to initialize pendo');
                        }
                    };
                    if (script instanceof HTMLScriptElement) script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
                    document.head.appendChild(script);
                }
            }
        });
    };
    const $929eebe0cae53103$var$addPendoWidget = (props)=>{
        const { atlassianAccountId: atlassianAccountId, cloudId: cloudId, cloudName: cloudName, appEditions: appEditions, apiKey: apiKey, editionKey: editionKey, appName: appName, language: language, displayMode: displayMode, environment: environment } = props;
        const pendoConfig = {
            visitor: {
                id: atlassianAccountId,
                language_preference: language,
                display_mode: displayMode
            },
            account: {
                id: `${appName}-${cloudId}`,
                workspace_name: cloudName,
                edition: editionKey === 'common' ? 'na' : appEditions?.[editionKey]
            },
            location: {
                transforms: [
                    {
                        attr: 'href',
                        action: 'Replace',
                        data: (href)=>`${(0, (0, parcelRequire("bw7Gm")).default)(href)}`
                    },
                    {
                        attr: 'pathname',
                        action: 'Replace',
                        data: (pathname)=>`${pathname}/${window?.globalPendoAppName}`
                    }
                ]
            },
            disableGuidePseudoStyles: true,
            guides: {
                preventCodeInjection: true,
                globalScripts: (0, (0, parcelRequire("4R6GH")).fg)('pendo-gsac-changes-globalscrips') ? $929eebe0cae53103$export$7be014228b4d4c4a : []
            }
        };
        $929eebe0cae53103$var$pendingRequestJira = $929eebe0cae53103$var$pendingRequestJira.then(()=>$929eebe0cae53103$var$initializePendoWithChecking(apiKey, appName, pendoConfig, environment));
    };
    const $929eebe0cae53103$export$7be014228b4d4c4a = [
        {
            script (_step, _guide) {
                const acceptedJavaScript = {
                    'window.location.href': window.location.href,
                    'window.location.pathname': window.location.pathname
                };
                const result = processFillPolls(acceptedJavaScript);
                function getValueFromFillPoll(fillPollText) {
                    const fillPollValue = fillPollText.split('{fillPoll: "')[1].split('"/}')[0];
                    return fillPollValue;
                }
                function processFillPolls(acceptedJavaScriptObject) {
                    const fillPollElements = window.pendo.dom('._pendo-open-text-poll-question p[id*="pendo-text"]:contains("{fillPoll")');
                    if (fillPollElements.length > 0) fillPollElements.each((el)=>{
                        const javascriptRule = getValueFromFillPoll(el.innerText);
                        const pollId = el.parentElement.parentElement.dataset.pendoPollId;
                        const textarea = document.querySelector(`textarea[data-pendo-poll-id="${pollId}"]`);
                        if (textarea) {
                            if (textarea instanceof HTMLTextAreaElement) textarea.value = `URL=${acceptedJavaScriptObject[javascriptRule]}`;
                        }
                    });
                    return fillPollElements;
                }
                return result;
            },
            test (step, _guide) {
                return step;
            }
        },
        {
            script (_step, _guide) {
                const result = processHiddenRows();
                function processHiddenRows() {
                    const hiddenRows = window.pendo.dom('div[id*="pendo-text"]:contains("{hidden/}")');
                    if (hiddenRows) hiddenRows.each((el)=>{
                        const elUpdated = el;
                        elUpdated.style.visibility = 'hidden';
                        elUpdated.style.display = 'none';
                        if (elUpdated.dataset.pendoPollId) {
                            const linkedPollElements = window.pendo.dom(`[data-pendo-poll-id="${elUpdated.dataset.pendoPollId}"]`);
                            if (linkedPollElements) linkedPollElements.each((linkedPollEl)=>{
                                const updatedLinkedPollEl = linkedPollEl;
                                if (updatedLinkedPollEl.nodeName === 'FORM') {
                                    updatedLinkedPollEl.parentNode.parentNode.style.visibility = 'hidden';
                                    updatedLinkedPollEl.parentNode.parentNode.style.display = 'none';
                                } else {
                                    updatedLinkedPollEl.style.visibility = 'hidden';
                                    updatedLinkedPollEl.style.display = 'none';
                                }
                            });
                        }
                    });
                    return hiddenRows;
                }
                return result;
            },
            test (step, _guide) {
                return step;
            }
        },
        {
            script (_step, _guide) {
                const result = processDeepLinkButton();
                function processDeepLinkButton() {
                    const button = window.pendo?.dom('button[id*="pendo-button"]');
                    if (button.length > 0 && button[0].innerHTML.includes('{{billing-preview-pendo}}')) {
                        button[0].innerHTML = button[0].innerHTML.replace('{{billing-preview-pendo}}', '');
                        button.on('click', ()=>{
                            const CLOUD_ADMIN_URL = `https://${(0, (0, parcelRequire("kTK0a")).getATLContextDomain)('admin')}`;
                            let newurl = CLOUD_ADMIN_URL;
                            const accountid = window.pendo?.getSerializedMetadata().account.id;
                            const dashindex = accountid.indexOf('-');
                            const cloudId = accountid.substring(dashindex + 1);
                            if (cloudId.length > 10) newurl = `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
                            window.pendo?.onGuideDismissed();
                            window.open(newurl, '_blank');
                        });
                    }
                    return button;
                }
                return result;
            },
            test (step, _guide) {
                return step;
            }
        }
    ];
    const $929eebe0cae53103$export$5b517672761df363 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const loadingRef = (0, $5uXOq.useRef)(false);
        const { loading: loading, error: error, data: data } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const environment = (0, (0, parcelRequire("2tT7R")).useEnvironment)();
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return;
            const projectContextLoaded = !loading && !error && data;
            const isProjectLoaded = loadingRef.current || projectContextLoaded;
            loadingRef.current = loading;
            if (isProjectLoaded && data?.projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return;
            const jiraAppName = data?.projectType || (0, $8e76b4dd832736a3$export$b40f9fec24e148b0);
            const { apiKey: apiKey, appName: appName, editionKey: editionKey } = (0, (0, parcelRequire("eJqJI")).APP_KEY_NAME_MAPPING)[jiraAppName];
            window.globalPendoAppName = appName;
            const pendoProps = {
                atlassianAccountId: tenantContext.atlassianAccountId,
                cloudId: tenantContext.cloudId,
                cloudName: tenantContext.cloudName,
                appEditions: tenantContext?.appEditions,
                displayMode: colorMode || 'light',
                language: tenantContext.locale,
                appName: appName,
                apiKey: apiKey,
                editionKey: editionKey,
                environment: environment
            };
            $929eebe0cae53103$var$addPendoWidget(pendoProps);
            return ()=>{
                window.globalPendoAppName = '';
            };
        }, [
            loading,
            error,
            data,
            tenantContext,
            tenantContext.atlassianAccountId,
            tenantContext.cloudId,
            tenantContext.cloudName,
            tenantContext.locale,
            colorMode,
            loadingRef,
            environment
        ]);
        return null;
    };
});
parcelRegister("902O6", function(module, exports) {
    $parcel$export(module.exports, "checkThirdParty", ()=>$ea550cf043223388$export$6112f3b5ec1bcd0);
    var $1qzRL;
    const $ea550cf043223388$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
        await (0, (0, parcelRequire("1qzRL")).checkThirdParty)(thirdParty, onAllowed, onDenied);
    };
});
parcelRegister("1qzRL", function(module, exports) {
    $parcel$export(module.exports, "checkThirdParty", ()=>$10a40a6a1d29fa54$export$6112f3b5ec1bcd0);
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    var $cwNy2;
    const $10a40a6a1d29fa54$export$6112f3b5ec1bcd0 = async (thirdParty, onAllowed, onDenied)=>{
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) return onAllowed();
        try {
            const isAllowed = await (0, (0, parcelRequire("cwNy2")).isThirdPartyAllowed)(thirdParty);
            (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedCheckThirdParty',
                attributes: {
                    wasRejected: !isAllowed,
                    thirdParty: thirdParty
                }
            });
            return isAllowed ? onAllowed() : onDenied === null || onDenied === void 0 ? void 0 : onDenied();
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'checkThirdPartyError',
                attributes: {
                    wasRejected: true,
                    thirdParty: thirdParty
                },
                message: `Failed to use check third party. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("cwNy2", function(module, exports) {
    $parcel$export(module.exports, "isThirdPartyAllowed", ()=>$91eee86a1f5f2f39$export$3df7084d4be668cd);
    var $8Ow66;
    var $iG1qD;
    var $8yV7s;
    const $91eee86a1f5f2f39$export$3df7084d4be668cd = async (thirdParty)=>{
        const preferences = await (0, (0, parcelRequire("8yV7s")).getPreferences)();
        if (!preferences) return Promise.resolve(false);
        let shouldDenyThirdParty = false;
        const storageControlsData = await (0, (0, parcelRequire("8Ow66")).loadStorageControlsData)();
        if (storageControlsData) {
            const { thirdPartyKeys: thirdPartyKeys, categories: categories } = storageControlsData;
            const thirdPartyCategoryNumber = thirdPartyKeys[thirdParty];
            const numToCategoryMap = {
                [categories.STRICTLY_NECESSARY]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).StrictlyNecessary,
                [categories.FUNCTIONAL]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Functional,
                [categories.ANALYTICS]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Analytics,
                [categories.MARKETING]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Marketing,
                [categories.UNKNOWN]: (0, (0, parcelRequire("iG1qD")).PreferenceCategory).Unknown
            };
            const thirdPartyCategory = thirdPartyCategoryNumber !== null ? numToCategoryMap[thirdPartyCategoryNumber] : null;
            let hasPreferencesForCategoryType = false;
            if (!!thirdPartyCategory) hasPreferencesForCategoryType = preferences[thirdPartyCategory];
            shouldDenyThirdParty = hasPreferencesForCategoryType;
        }
        return Promise.resolve(shouldDenyThirdParty);
    };
});
parcelRegister("8yV7s", function(module, exports) {
    $parcel$export(module.exports, "getPreferences", ()=>$63bdce623eb86acc$export$1de6a888ae076ff8);
    var $VSDnB;
    var $e7OnS;
    var $jlKyx;
    var $eMLDH;
    var $4qYnX;
    async function $63bdce623eb86acc$export$1de6a888ae076ff8() {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls-v2')) {
            const packedPrefs = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
            if (!packedPrefs) return undefined;
            return (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(packedPrefs);
        }
        let packedLocalPrefs = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, (0, parcelRequire("jlKyx")).getConsentToken)();
            return consentToken ? (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, (0, parcelRequire("4qYnX")).unpackUserPreferencesCookie)(packedLocalPrefs);
    }
});
parcelRegister("jlKyx", function(module, exports) {
    $parcel$export(module.exports, "getConsentToken", ()=>$e1641792109b47e6$export$f1b8f2ca713fca08);
    var $e7OnS;
    var $eMLDH;
    var $hqdIW;
    var $dKrpM;
    var $lxnql;
    const $e1641792109b47e6$export$f1b8f2ca713fca08 = async ()=>{
        const fallbackConsentToken = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        const consentData = await (0, (0, parcelRequire("lxnql")).getValidConsentData)(fallbackConsentToken);
        if (consentData) {
            const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
            const potentiallyOverriddenConsentToken = (0, (0, parcelRequire("hqdIW")).overrideConsentTokenForLiveTesting)(consentToken);
            const testingConsentOverride = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
            const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
            if (hasTestingConsents) {
                (0, (0, parcelRequire("dKrpM")).setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
                (0, (0, parcelRequire("dKrpM")).setConsentTokenCookie)(potentiallyOverriddenConsentToken);
                return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
            }
            (0, (0, parcelRequire("dKrpM")).setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
            return consentToken;
        }
        return undefined;
    };
});
parcelRegister("hqdIW", function(module, exports) {
    $parcel$export(module.exports, "overrideConsentTokenForLiveTesting", ()=>$caef82a1e737c7f7$export$b5282052fc15e1ae);
    var $e7OnS;
    var $eMLDH;
    const $caef82a1e737c7f7$export$b5282052fc15e1ae = (genuineConsentToken)=>{
        const tokenOverride = (0, (0, parcelRequire("eMLDH")).getCookie)((0, (0, parcelRequire("e7OnS")).TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        return tokenOverride || genuineConsentToken;
    };
});
parcelRegister("dKrpM", function(module, exports) {
    $parcel$export(module.exports, "setConsentTokenCookie", ()=>$a024d63fdab5034c$export$8e560d0760f733a2);
    $parcel$export(module.exports, "setConsentTokenFallbackCookie", ()=>$a024d63fdab5034c$export$133cd762b0f705a2);
    $parcel$export(module.exports, "setShouldShowBannerCookie", ()=>$a024d63fdab5034c$export$99ecece88c58d938);
    $parcel$export(module.exports, "setRequiredConsentCookies", ()=>$a024d63fdab5034c$export$b3365240280cb3c3);
    var $1Vlui;
    var $e7OnS;
    var $fIz84;
    var $GjM2o;
    const $a024d63fdab5034c$export$8e560d0760f733a2 = (consentToken)=>{
        const inTenMinutes = new Date();
        inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
            expires: inTenMinutes,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$133cd762b0f705a2 = (consentToken)=>{
        const inOneYear = new Date();
        inOneYear.setFullYear(inOneYear.getFullYear() + 1);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
            expires: inOneYear,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
        const bannerVisibility = (0, (0, parcelRequire("fIz84")).getBannerVisibility)({
            consentToken: consentToken,
            consentTimestamp: consentTimestamp
        });
        const shouldShowBanner = (0, (0, parcelRequire("1Vlui")).getBitValueFromBool)(!!bannerVisibility);
        const inTenMinutes = new Date();
        inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)((0, (0, parcelRequire("e7OnS")).ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
            expires: inTenMinutes,
            path: '/'
        });
    };
    const $a024d63fdab5034c$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
        $a024d63fdab5034c$export$8e560d0760f733a2(consentToken);
        $a024d63fdab5034c$export$99ecece88c58d938(consentToken, consentTimestamps);
    };
});
parcelRegister("GjM2o", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$07f3430601091fbe$export$93509ff9a62ee022);
    var $eYli8 = parcelRequire("eYli8");
    var $VSDnB;
    var $aGNyr;
    var $cala7;
    const $07f3430601091fbe$export$93509ff9a62ee022 = (key, value, attributes)=>{
        try {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedSetStrictlyNecessaryCookie',
                attributes: {
                    cookieKey: key
                }
            });
            (0, ($parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedSetStrictlyNecessaryCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("lxnql", function(module, exports) {
    $parcel$export(module.exports, "getValidConsentData", ()=>$faded98915bfbca5$export$c515de1cc9cebc71);
    var $j78Eu;
    var $4qYnX;
    const $faded98915bfbca5$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
        const consentData = await (0, (0, parcelRequire("j78Eu")).fetchConsentPreferences)();
        let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
        let { isValid: isValid } = (0, (0, parcelRequire("4qYnX")).checkTokenVersionValidity)(consentToken);
        if (isValid && consentHubInaccessible) {
            if (fallbackConsentToken) consentToken = fallbackConsentToken;
            else consentToken = `${consentToken.slice(0, 8)}1111`;
        }
        return isValid ? {
            consentToken: consentToken,
            consentTimestamp: consentTimestamp
        } : undefined;
    };
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $4zICj;
    var $8r6xd;
    var $TTRxY;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("4zICj")).choreographerFactory)((0, (0, parcelRequire("TTRxY")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("8r6xd")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("TTRxY")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $iZhen;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("iZhen")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("iZhen")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("iZhen")).envType).PROD;
            default:
                return (0, (0, parcelRequire("iZhen")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("eJqJI", function(module, exports) {
    $parcel$export(module.exports, "APP_KEY_NAME_MAPPING", ()=>$1dbeaa4a630423c8$export$e1484ba0e8570538);
    const $1dbeaa4a630423c8$var$API_KEY_JIRA = '0678af2a-df89-42a3-4abb-60978aa54814';
    const $1dbeaa4a630423c8$export$e1484ba0e8570538 = {
        business: {
            apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
            appName: 'jwm',
            editionKey: 'core'
        },
        software: {
            apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
            appName: 'jsw',
            editionKey: 'software'
        },
        service_desk: {
            apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
            appName: 'jsm',
            editionKey: 'serviceDesk'
        },
        customer_service: {
            apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
            appName: 'jcs',
            editionKey: 'customerService'
        },
        common: {
            apiKey: $1dbeaa4a630423c8$var$API_KEY_JIRA,
            appName: 'common',
            editionKey: 'common'
        },
        product_discovery: {
            apiKey: '',
            appName: 'jpd',
            editionKey: 'productDiscovery'
        }
    };
});
const $8e76b4dd832736a3$export$b40f9fec24e148b0 = 'common';
parcelRegister("fHuqs", function(module, exports) {
    const $b6e279191b667d1d$var$style = document.createElement('style');
    $b6e279191b667d1d$var$style.textContent = `#pendo-guide-container ._pendo-backdrop{background:var(--ds-blanket,#091e427f)!important}#pendo-guide-container{background-color:var(--ds-surface-overlay,#fff)!important;box-shadow:var(--ds-shadow-overlay,0px 0px 8px #091e4229,0px 0px 1px #091e421f)!important;border:var(--ds-border,#091e4224)!important;border-radius:var(--ds-border-radius,3px)!important}#pendo-guide-container [id^=pendo-guide-data-text]{color:var(--ds-text,#172b4d)!important}#pendo-guide-container .pendo-tooltip-caret--top,#pendo-guide-container .pendo-tooltip-caret--top+.pendo-tooltip-caret-border{border-top-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--right,#pendo-guide-container .pendo-tooltip-caret--right+.pendo-tooltip-caret-border{border-right-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--bottom{border-bottom-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--left{border-left-color:var(--ds-surface-overlay,#fff)!important}#pendo-guide-container .pendo-tooltip-caret--top+.pendo-tooltip-caret-border{border-top-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--right+.pendo-tooltip-caret-border{border-right-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--bottom+.pendo-tooltip-caret-border{border-bottom-color:var(--ds-border,#091e4224)!important}#pendo-guide-container .pendo-tooltip-caret--left+.pendo-tooltip-caret-border{border-left-color:var(--ds-border,#091e4224)!important}#pendo-guide-container ._pendo-text-paragraph,#pendo-guide-container ._pendo-text-custom,#pendo-guide-container ._pendo-text-subTitle,#pendo-guide-container ._pendo-text-title,#pendo-guide-container ._pendo-nps-open-text-poll-question{color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link,#pendo-guide-container ._pendo-text-custom ._pendo-text-link,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link,#pendo-guide-container ._pendo-text-title ._pendo-text-link{color:var(--ds-link,#0052cc)!important;text-decoration:underline!important}#pendo-guide-container ._pendo-button{border-radius:var(--ds-border-radius,3px)!important;font-weight:var(--ds-font-weight-medium,500)!important}#pendo-guide-container ._pendo-button-primaryButton{background-color:var(--ds-background-brand-bold,#0c66e4)!important;color:var(--ds-text-inverse,#fff)!important}#pendo-guide-container ._pendo-button-tertiaryButton,#pendo-guide-container ._pendo-button-custom{background-color:var(--ds-background-neutral-subtle,#0000)!important;color:var(--ds-text-subtle,#44546f)!important}#pendo-guide-container div[class*=_pendo-number-scale-poll]{color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-multi-choice-poll-select-border{border-width:var(--ds-border-width-0,0px)!important;background-color:#0000!important}#pendo-guide-container ._pendo-multi-choice-poll-select{cursor:pointer;box-sizing:border-box;background-color:var(--ds-background-neutral,#091e420f)!important;color:var(--ds-text,#42526e)!important;border-radius:var(--ds-border-radius-100,3px)!important}#pendo-guide-container [id^=pendo-radio-select-] label.pendo-radio{color:var(--ds-text,#172b4d)!important;margin-top:2px!important}#pendo-guide-container ._pendo-open-text-poll-input{background-color:var(--ds-background-input,#fff)!important;border:1px solid var(--ds-border-input,#8590a2)!important;border-radius:var(--ds-border-radius,3px)!important;color:var(--ds-text,#091e42)!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]{background-color:var(--radio-background-color);border:var(--ds-border-width,1px)solid var(--radio-border-color);border-radius:var(--ds-border-radius-circle,50%);--radio-background-color:var(--ds-background-input,#fff);--radio-border-color:var(--ds-border-input,#8590a2);outline:none;width:var(--ds-space-300,24px)!important;height:var(--ds-space-300,24px)!important;margin:var(--ds-space-0,0px)!important;--radio-dot-color:var(--ds-icon-inverse,#fff)!important;--radio-dot-opacity:0!important;vertical-align:top!important;appearance:none!important;flex-shrink:0!important;justify-content:center!important;align-items:center!important;transition:border-color .2s ease-in-out,background-color .2s ease-in-out!important;display:flex!important;position:relative!important;transform:scale(.58333)!important}#pendo-guide-container ._pendo-required-indicator{color:var(--ds-text-danger,#ae2e24)!important;font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;padding-inline-start:var(--ds-space-025,2px)!important}#pendo-guide-container :focus-visible::-moz-focus-inner:not(.pendo-start-focus-bumper:focus-visible:-moz-focus-inner .pendo-end-focus-bumper:focus-visible:-moz-focus-inner){border-radius:var(--ds-border-radius,3px)!important}#pendo-guide-container :focus-visible:not(.pendo-start-focus-bumper:focus-visible,.pendo-end-focus-bumper:focus-visible,.pendo-radio:focus-visible,._pendo-open-text-poll-input:focus-visible,._pendo-close-guide:focus-visible,._pendo-multi-choice-poll-select-border){outline:none!important;outline-color:var(--ds-border-focused,#388bff)!important;outline-width:var(--ds-border-width-outline,2px)!important;outline-offset:var(--ds-space-025,2px)!important;border-radius:var(--ds-border-radius,3px)!important;outline-style:solid!important}#pendo-guide-container ._pendo-close-guide:focus-visible{outline-offset:0px!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]:checked{--radio-background-color:var(--ds-background-selected-bold,#0052cc)!important;--radio-border-color:var(--ds-background-selected-bold,#0052cc)!important;--radio-dot-opacity:1!important}#pendo-guide-container [id^=pendo-radio-select] input[type=radio]:after{background:var(--radio-dot-color);border-radius:var(--ds-border-radius-circle,50%);content:"";opacity:var(--radio-dot-opacity);width:6.85714px;height:6.85714px;transition:background-color .2s ease-in-out,opacity .2s ease-in-out;position:absolute}#pendo-guide-container .pendo-radio:focus-visible{outline:var(--ds-border-width-outline,3px)solid var(--ds-border-focused,#2684ff)!important;outline-offset:var(--ds-border-width-indicator,3px)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-custom ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:hover,#pendo-guide-container ._pendo-text-title ._pendo-text-link:hover{color:var(--ds-link,#0052cc)!important;text-decoration:underline!important}#pendo-guide-container ._pendo-button-primaryButton:hover{background-color:var(--ds-background-brand-bold-hovered,#05c)!important}#pendo-guide-container ._pendo-button-secondaryButton:hover,#pendo-guide-container ._pendo-button-tertiaryButton:hover,#pendo-guide-container ._pendo-button-custom:hover{color:var(--ds-text-subtle,#44546f)!important;background-color:var(--ds-background-neutral-hovered,#091e4224)!important}#pendo-guide-container ._pendo-button:disabled._pendo-button[disabled]{border-radius:var(--ds-border-radius-100,3px)!important;border-color:currentColor!important;border-width:var(--ds-border-width-0,0px)!important;text-align:center!important;background-color:var(--ds-background-disabled,#091e4208)!important;color:var(--ds-text-disabled,#091e424f)!important;cursor:not-allowed!important;pointer-events:auto!important;padding-inline-start:var(--ds-space-150,12px)!important;padding-inline-end:var(--ds-space-150,12px)!important;text-decoration:none!important;transition:background .1s ease-out,box-shadow .15s cubic-bezier(.47,.03,.49,1.38)!important}#pendo-guide-container ._pendo-open-text-poll-input::placeholder{color:var(--ds-text-subtlest,#6b778c)!important}#pendo-guide-container ._pendo-close-guide{top:var(--ds-space-250,20px)!important;right:var(--ds-space-250,20px)!important;color:var(--ds-icon,#172b4d)!important;border-radius:var(--ds-border-radius,3px)!important;cursor:pointer!important;justify-content:center!important;align-items:center!important;width:32px!important;height:32px!important;padding-bottom:5px!important;font-size:30px!important;font-weight:300!important;transition:background .1s ease-out!important;display:flex!important}#pendo-guide-container ._pendo-close-guide:hover{background-color:var(--ds-background-neutral-subtle-hovered,#091e420f)!important;color:var(--ds-icon,#172b4d)!important}#pendo-guide-container ._pendo-close-guide:active{background-color:var(--ds-background-neutral-subtle-pressed,#091e4224)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio{background-color:var(--ds-background-input,#fff)!important;border-width:var(--ds-border-width,1px)!important;border-style:solid!important;border-color:var(--ds-border-input,#8590a2)!important;color:var(--ds-text,#172b4d)!important;justify-content:center!important;align-items:center!important;display:flex!important}#pendo-guide-container label[class*=_pendo-number-scale-poll]{margin-left:0!important;margin-right:4px!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper .pendo-radio:active{background-color:var(--ds-background-input-pressed,#fff)!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type=radio].pendo-radio:checked+label{background-color:var(--ds-background-selected,#cce0ff)!important;color:var(--ds-text-selected,#0c66e4)!important;border-color:var(--ds-border-selected,#0c66e4)!important;border-width:2px!important}#pendo-guide-container ._pendo-button-primaryButton._pendo-button:hover{background:var(--ds-background-brand-bold-hovered,#05c)!important}#pendo-guide-container ._pendo-button-primaryButton._pendo-button:active{background:var(--ds-background-brand-bold-pressed,#09326c)!important}#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:hover,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button:hover,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:hover{background:var(--ds-background-neutral-hovered,#091e4224)!important}#pendo-guide-container ._pendo-button-secondaryButton._pendo-button:active ._pendo-button._pendo-yes-no-poll-yes-button:active,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button:active{background:var(--ds-background-neutral-pressed,#091e424f)!important}#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:hover{background:var(--ds-background-neutral-subtle-hovered,#091e420f)!important}#pendo-guide-container ._pendo-button-tertiaryButton._pendo-button:active{background:var(--ds-background-neutral-subtle-pressed,#091e4224)!important}#pendo-guide-container h2{font:var(--ds-font-heading-medium,normal 500 20px/24px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-bottom:var(--ds-space-100,8px)!important}#pendo-guide-container h3{font:var(--ds-font-heading-small,normal 600 16px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-top:4px!important;margin-bottom:var(--ds-space-100,8px)!important}#pendo-guide-container ._pendo-text-paragraph._pendo-open-text-poll-question,#pendo-guide-container ._pendo-text-paragraph._pendo-multi-choice-poll-question{padding-top:var(--ds-space-100,4px)!important;margin-bottom:var(--ds-space-050,4px)!important;color:var(--ds-text-subtle,#44546f)!important;font:400 12px/16px ui-sans-serif,-apple-system,BlinkMacSystemFont,Segoe UI,Ubuntu,system-ui,Helvetica Neue,sans-serif!important;font-weight:var(--ds-font-weight-semibold,600)!important}#pendo-guide-container ._pendo-text-paragraph{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important}#pendo-guide-container ._pendo-number-scale-poll-1-description,#pendo-guide-container ._pendo-number-scale-poll-5-description{margin-top:var(--ds-space-050,4px)!important;color:var(--ds-text-subtle,#44546f)!important}#pendo-guide-container label.pendo-radio:hover,#pendo-guide-container input[type=radio].pendo-radio:checked+label{background-color:#0000!important}#pendo-guide-container ._pendo-multi-choice-poll-select-border input[type=radio].pendo-radio:focus+label{outline:none!important}#pendo-guide-container ._pendo-number-scale-poll-wrapper input[type=radio].pendo-radio:focus+label{outline-offset:4px!important;outline-color:var(--ds-border-focused,#388bff)!important}#pendo-guide-container{padding:var(--ds-space-300,24px)!important}#pendo-guide-container ._pendo-open-text-poll-input{transition:background-color .2s ease-in-out,border-color .2s ease-in-out;font-family:var(--ds-font-family-body,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",Ubuntu,system-ui,"Helvetica Neue",sans-serif)!important;margin-block:0!important}#pendo-guide-container ._pendo-open-text-poll-input:focus-visible{box-shadow:inset 0 0 0 var(--ds-border-width,1px)var(--ds-border-focused,#2684ff)!important;border-color:var(--ds-border-focused,#2684ff)!important;outline:none!important}#pendo-guide-container ._pendo-open-text-poll-input:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-multi-choice-poll-select{background:var(--ds-background-input,#fff)!important;border-width:var(--ds-border-width,1px)!important;border:solid var(--ds-border-input,#8590a2)!important;padding-inline:var(--ds-space-075,6px)!important;padding-block:var(--ds-space-025,2px)!important;transition:background-color .2s ease-in-out,border-color .2s ease-in-out!important}#pendo-guide-container ._pendo-multi-choice-poll-select:hover{background-color:var(--ds-background-input-hovered,#f7f8f9)!important}#pendo-guide-container ._pendo-multi-choice-poll-select:active{background-color:var(--ds-background-input-pressed,#fff)!important}#pendo-guide-container hr{border-color:var(--ds-border,#091e4224)!important;margin-block:var(--ds-space-100,8px)!important;border-width:var(--ds-border-width,1px)0 0!important}#pendo-guide-container ._pendo-button{height:var(--ds-space-400,32px)!important;padding-inline:var(--ds-space-150,12px)!important;cursor:pointer!important;padding-block:0!important;font-weight:500!important;transition:background .1s ease-out!important}#pendo-guide-container ._pendo_button:hover,#pendo-guide-container ._pendo_button:active{transition-duration:0s!important}#pendo-guide-container ._pendo-button-secondaryButton,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-yes-button,#pendo-guide-container ._pendo-button._pendo-yes-no-poll-no-button{background-color:var(--ds-background-neutral,#091e420f)!important;color:var(--ds-text,#172b4d)!important}#pendo-guide-container ._pendo-text-paragraph ._pendo-text-link:active,#pendo-guide-container ._pendo-text-custom ._pendo-text-link:active,#pendo-guide-container ._pendo-text-subTitle ._pendo-text-link:active,#pendo-guide-container ._pendo-text-title ._pendo-text-link:active{color:var(--ds-link-pressed,#05c)!important}`;
    document.querySelector('head').appendChild($b6e279191b667d1d$var$style);
});
